const HeroSection = () => {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/268c12f9-6f0c-4f04-8429-977039a29bee/b0919aee-9823-4335-80f5-c1f856790c16_-.jpg?v=b542e6abda15520a8dce137d40d0df5c"
          alt="삼성콘크리트 보강토 옹벽 시공 현장"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/15 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 lg:px-10 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 rounded-full px-3 py-1.5 mb-5">
            <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
            <span className="text-orange-400 text-xs font-semibold tracking-wider uppercase">
              블럭식 보강토 옹벽 전문기업
            </span>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-5xl lg:text-7xl font-black text-white leading-tight mb-4">
            견고하고 안전한<br />
            <span className="text-orange-500">옹벽 시스템</span>
          </h1>

          {/* Description - 모바일에서 숨김 */}
          <p className="hidden sm:block text-white/70 text-base leading-relaxed mb-8 max-w-lg">
            친환경 R&amp;D 연구개발로 자연을 지키는<br />
            보강토 옹벽 전문 제조기업입니다.
          </p>

          {/* CTA Buttons */}
          <div className="flex gap-3 mb-8 sm:mb-0">
            <button
              onClick={() => handleScroll("#products")}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-5 py-3 sm:px-8 sm:py-4 rounded-full text-sm sm:text-base transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              제품 보기
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => handleScroll("#contact")}
              className="border-2 border-white/50 hover:border-white text-white font-bold px-5 py-3 sm:px-8 sm:py-4 rounded-full text-sm sm:text-base transition-all cursor-pointer whitespace-nowrap"
            >
              견적 문의
            </button>
          </div>

          {/* Stats Bar - 모바일에서 간소화 */}
          <div className="flex gap-5 sm:gap-8 mt-8 sm:mt-16 pt-6 sm:pt-10 border-t border-white/20">
            <div>
              <div className="text-2xl sm:text-4xl font-black text-orange-500">10,000+</div>
              <div className="text-white/60 text-xs sm:text-sm mt-0.5">시공 실적</div>
            </div>
            <div>
              <div className="text-2xl sm:text-4xl font-black text-orange-500">5종</div>
              <div className="text-white/60 text-xs sm:text-sm mt-0.5">전문 제품군</div>
            </div>
            <div>
              <div className="text-lg sm:text-2xl font-black text-orange-500 leading-tight">KS<br className="sm:hidden" /> 인증</div>
              <div className="text-white/60 text-xs sm:text-sm mt-0.5">품질 인증</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - 모바일 숨김 */}
      <div className="hidden sm:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
};

export default HeroSection;
